const sunExposureValues = {
    1: '<30 min',
    2: '30-60 min',
    3: '>60 min',
}

export default sunExposureValues;
